import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Tracking = Loadable({
  loader: () => import("./routes/tracking"),
  loading: TopBarProgress,
});
const Profile = Loadable({
  loader: () => import("./routes/profile"),
  loading: TopBarProgress,
});

const Owner = () => (
  <Switch>
    <Route path="/tracking">
      <Tracking />
    </Route>
    <Route path="/profile">
      <Profile />
    </Route>
    <Redirect to="/tracking" />
  </Switch>
);

export default Owner;
